import { initialIntOutBoundFileState, actions } from "./action";

export const IntOutBoundFileReducer = (state = initialIntOutBoundFileState, action) => {
    switch (action.type) {
        case actions.INTOUTBOUNDFILE_GET_ALL_SUCCESS:
            return {
                ...state,
                intoutboundfileList: action.payload ? action.payload : {}
            };
        case actions.INTOUTBOUNDFILE_RESET_SUCCESS:
            return {
                ...state,
                intoutboundfile: {},
                filters: {}
            };
        case actions.INTOUTBOUNDFILE_SET_FILTERS_REQUEST:
            return {
                ...state,
                filters: action.payload
            };
        default:
            return state;
    }
};
